<template>
  <div class="page page--location">
    <Ezoic id="101" />
    <h1>
      <router-link :to="pathForLocale({path: '/'})">
        {{ this.currentPage.title }}
      </router-link>
    </h1>
    <AddressReading :page="this.currentPage" />
    <Ezoic id="103" />
    <WikipediaInfo />
    <Ezoic id="104" />
    <TheFooter :pages="pages" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pathForLocale } from '@/helpers';
import Ezoic from '@/components/Ezoic.vue';
import TheFooter from '@/components/TheFooter.vue';
import AddressReading from '@/components/AddressReading.vue';
import WikipediaInfo from '@/components/WikipediaInfo.vue';

export default {
  components: {
    Ezoic,
    TheFooter,
    AddressReading,
    WikipediaInfo,
  },
  metaInfo() {
    return {
      title: this.currentPage.field !== 'formattedAddress' ? this.currentPage.title : null,
    };
  },
  props: {
    title: { type: String },
    latitude: { type: String },
    longitude: { type: String },
  },
  computed: {
    ...mapState(['location']),
    pages() {
      return {
        address: {
          field: 'formattedAddress',
          title: 'What is my address?',
        },
        city: {
          field: 'locality',
          title: 'What is my city?',
        },
        zipcode: {
          field: 'postalCode',
          title: 'What is my ZIP code?',
        },
        county: {
          field: 'adminDistrict2',
          title: 'What is my county?',
        },
        state: {
          field: 'adminDistrict',
          title: 'What is my state?',
        },
        country: {
          field: 'countryRegion',
          title: 'What is my country?',
        },
        neighborhood: {
          field: 'neighborhood',
          title: 'What is my neighborhood?',
        },
        intersection: {
          field: 'intersection',
          title: 'What is my intersection?',
        },
        coordinates: {
          field: 'coordinates',
          title: 'What are my GPS coordinates?',
        },
      };
    },
    currentPage() {
      if (this.$route.name in this.pages) {
        return this.pages[this.$route.name];
      }
      return this.pages.address;
    },
  },
  methods: {
    pathForLocale,
  },
  created() {
    this.$store.dispatch('watchUserLocation');
  },
};
</script>
